import angular from 'angular';
import uploadHistoryComponent from './uploadHistory.component';

let uploadHistoryModule = angular.module('uploadHistory', []).component('uploadHistory', uploadHistoryComponent);

export default uploadHistoryModule;



// WEBPACK FOOTER //
// ./app/components/uploadHistory/uploadHistory.js